module.exports = __webpack_public_path__ + "static/media/lavadeira-rio-identidade-visual-logotipo.c47dfede.jpg";